import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import {
  TInheritedProps,
  IDataGridConfig,
  generateGlobalColumns,
  generateBooleanColumn,
  generateEntityColumn,
} from '@ts/storybook';
import { useAppSelector } from '@redux/store';
import { IConfigComponent, COrganization, CRole } from '@ts/ui-models';

interface IUserRolesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  title?: string;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'userRoles',
  aclId: 'taRole',
  fetchURL: `/api/v2/user/{userId}/organization/{organizationId}/roles`,
};

const UserRoles = (props: IUserRolesProps) => {
  const { title, configComponent = defaultConfigComponent, inheritedProps } = props;
  const badge = useAppSelector(state => state.global.sessionBadge);
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
    //sortModel: [{ field: 'name', sort: 'asc' }],
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      generateEntityColumn({ field: 'role' }, { mainClass: CRole }, { inheritedProps }),
      generateEntityColumn({ field: 'organization' }, { field: 'organization', mainClass: COrganization }, { inheritedProps }),
      generateBooleanColumn({ field: 'isAdmin', headerName: 'Admin' }, { field: 'isAdmin' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      title={title}
      configComponent={{
        ...configComponent,
        fetchURL: `/api/v2/user/${badge?.userId}/organization/${badge?.organizationId}/roles`,
      }}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={inheritedProps}
    />
  );
};

export default UserRoles;
